define("calendar/components/calendar/settings/notes", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <hr class="u--m__b__0" />
  <div class="u--row">
    <div class="u--col__4 u--m__t__md">
      <h5 class="u--text--md u--m__0" data-test-id="calendar-settings-notes-title">
        {{t "calendar.settings.calendar_notes_title"}}
      </h5>
    </div>
    <div class="u--col__8 u--m__t__md">
      {{#if this.canCalendarNotes}}
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "calendar.settings.calendar_notes_label"}}
          @propertyToggled={{@showCalendarNotes}}
          @toggleAction={{@toggleCalendarNotes}}
          class="u--p__0 u--m__b"
          data-test-notes="settings-checkbox"
        />
      {{else}}
        <h5 class="u--text--md u--m__t__0">
          {{t "calendar_notes.try"}}
        </h5>
  
        <p class="u--text--light">
          {{t "calendar_notes.notes_settings_sub_text"}}
        </p>
  
        <Shared::Button::Upgrade
          @feature="calendarNotes"
          @location="calendar settings note"
          @seamlessCheckoutSuccessCallback={{@closeSettingsModal}}
          @text={{this.upgradeButtonText}}
          @variant="proceed"
        />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "UnCHA6Zj",
    "block": "[[[10,\"hr\"],[14,0,\"u--m__b__0\"],[12],[13],[1,\"\\n\"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__0\"],[14,\"data-test-id\",\"calendar-settings-notes-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.calendar_notes_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8 u--m__t__md\"],[12],[1,\"\\n\"],[41,[30,0,[\"canCalendarNotes\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"u--p__0 u--m__b\"],[24,\"data-test-notes\",\"settings-checkbox\"]],[[\"@labelText\",\"@propertyToggled\",\"@toggleAction\"],[[28,[37,0],[\"calendar.settings.calendar_notes_label\"],null],[30,1],[30,2]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"calendar_notes.try\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"calendar_notes.notes_settings_sub_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,3],null,[[\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@text\",\"@variant\"],[\"calendarNotes\",\"calendar settings note\",[30,3],[30,0,[\"upgradeButtonText\"]],\"proceed\"]],null],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@showCalendarNotes\",\"@toggleCalendarNotes\",\"@closeSettingsModal\"],false,[\"t\",\"if\",\"shared/ui/checkbox-switch\",\"shared/button/upgrade\"]]",
    "moduleName": "calendar/components/calendar/settings/notes.hbs",
    "isStrictMode": false
  });

  let NotesComponent = (_class = class NotesComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }

    get canCalendarNotes() {
      return Boolean(this.auth.currentAccount.canCalendarNotes);
    }

    get upgradeButtonText() {
      if (this.subscriptions.isEligibleForTrial) {
        return this.intl.t('authorization.sign_up_trial.button_yes');
      } else if (this.subscriptions.hasActiveTrial && !this.canCalendarNotes) {
        return this.intl.t('plans.upgrade.upgrade_trial');
      }

      return this.intl.t('shared_phrases.upgrade_plan');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = NotesComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NotesComponent);
});